<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                :default-expand-all="false"
                style="width: 100%">
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="userId" label="用户ID" align="center">
                </el-table-column>
                <el-table-column prop="nickName" label="用户昵称" align="center">
                </el-table-column>
                <!-- <el-table-column prop="phone" label="用户手机" align="center">
                </el-table-column> -->
                <el-table-column prop="header" label="用户头像" align="center">
                    <template slot-scope="scope">
                        <el-image
                        style="width: 40px; height: 40px"
                        :src="scope.row.header"
                        :preview-src-list="[scope.row.header]"
                        v-if="scope.row.header"
                        fit="cover"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="content" label="内容" align="center" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column prop="paths" label="图片" align="center"></el-table-column> -->
                <el-table-column prop="fengJinDay" label="封禁天数" align="center"></el-table-column>
                <el-table-column prop="fengJinRemark" label="封禁原因" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="operationState" label="审核状态" align="center">
                    <template slot-scope="scope">
                        <el-tag type="warning" v-if="scope.row.operationState == 0">未处理</el-tag>
                        <el-tag v-if="scope.row.operationState == 1">已处理</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="operationTime" label="审核时间" align="center"></el-table-column>
                <el-table-column prop="operationContent" label="审核内容" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" label="操作" width="100px" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="detailShow(scope.row)">查看</el-button>
                        <el-button type="text" size="mini" @click="detailShow(scope.row)">解封</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </div>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isDetailDialog" title="查询详情" width="750px">
            <!-- <forms ref="formListDetail" :list="formList" :value="formData" :rules="formRules" :btns="formDetailBtns" labelWidth="120px"></forms> -->
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        用户ID
                    </div>
                    <div class="value">
                        <el-input v-model="detailData.userId" size="small" placeholder="" disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        用户昵称
                    </div>
                    <div class="value">
                        <el-input v-model="detailData.nickName" size="small" placeholder="" disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        用户头像
                    </div>
                    <div class="value">
                        <el-image
                        style="width: 80px; height: 80px"
                        :src="detailData.header"
                        :preview-src-list="[detailData.header]"
                        v-if="detailData.header"
                        fit="cover"></el-image>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        用户手机
                    </div>
                    <div class="value">
                        <el-input v-model="detailData.phone" size="small" placeholder="" disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        内容
                    </div>
                    <div class="value">
                        <el-input v-model="detailData.content" size="small" placeholder="" type="textarea" disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        图片
                    </div>
                    <div class="value">
                        <div class="picList">
                            <div class="pic" v-for="(item,index) in detailData.pathList" :key="index">
                                <el-image
                                style="width: 80px; height: 80px"
                                :src="item"
                                :preview-src-list="[item]"
                                fit="cover"

                                ></el-image>
                                <!-- <img class="pic-edit" src="../../../assets/images/icon08.png" alt="" @click="clearEditPath(index)"> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="item">
                    <div class="label">
                        封禁天数
                    </div>
                    <div class="value">
                        <el-input v-model="detailData.fengJinDay" size="small" placeholder="" disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        封禁原因
                    </div>
                    <div class="value">
                        <el-input v-model="detailData.fengJinRemark" size="small" placeholder="" type="textarea" disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        申诉状态
                    </div>
                    <div class="value">
                        <el-radio v-model="detailData.operationState" :label="item.value" v-for="(item,index) in operationStateList" :key="index">{{ item.label }}</el-radio>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        申诉时间
                    </div>
                    <div class="value">
                        <el-input v-model="detailData.operationTime" size="small" placeholder=""></el-input>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        申诉内容
                    </div>
                    <div class="value">
                        <el-input v-model="detailData.operationContent" size="small" placeholder="" type="textarea"></el-input>
                    </div>
                </div>
                <div class="btns">
                    <el-button type="primary" @click="submitData">确认提交</el-button>
                </div>
            </div>
        
        </el-dialog>
        
        
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {parseTimeS} from '../../../utils/index'
  
const operationStateList = [{label:'未处理',value:0},{label:'已处理',value:1}]
export default {
    name: 'person',
    components:{
        queryCondition,
        forms,
    },
    watch: {
    },
    data () {
        return {
            isAddDialog:false,
            isUpdateDialog:false,
            isDetailDialog:false,
            formData:{},
            formDataAdd:{
                "parentId": "",
                "name": "",
                "sort": 0,
                "imgUrl": "",
                "isShow": true,
            },
            totalCount:0,
            // tableData:[],
            tableData: [
                
            ],
            operationStateList:operationStateList,
            conditionData:{
                operationState: null,
                userId: "",
                phone: "",
                pageSize: 10,
                page: 1
            },
            queryList:[
                {type: "input",label: "用户ID:",name: "userId"},
                // {type: "input",label: "手机号:",name: "phone"},
                {type: "select",label: "发送者城市:",name: "operationState",options:operationStateList},
            ],
            detailData:{}
           
            
           
        }
    },
    created(){
    },
    mounted(){
        this.loadingData();
    },
    methods:{
        async submitData(){
            let res  = await api.UpdateOperationState({
                "id": this.detailData.id,
                "operationState": this.detailData.operationState,
                "operationContent": this.detailData.operationContent
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '修改成功'
                })
                this.isDetailDialog = false;
                this.loadingData();
            }
        },
        // table表头样式
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 加载table数据
        async loadingData() {
            let res  = await api.QueryAppeal(this.conditionData);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
            // for(let index = 0;index<tableData.length;index++){
            //     tableData[index].creatTimeStr = parseTimeS(tableData[index].creatTime)
                
            // }
            console.log(this.tableData);
        },
        // 查询
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        // 重置查询
        reset(){
            this.conditionData = {
                sendPhone: "",
                toPhone: "",
                sendCity: "",
                toCity: "",
                pageSize: 10,
                page: 1 
            },
            this.loadingData();
        },
        // 切换页面
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        // 切换页面条数
        handleSizeChange(pageSize){
            this.conditionData.page = 1;
            this.conditionData.pageSize = pageSize;
            this.loadingData();
        },
        showAddDialog(){
            this.isAddDialog = true;
        },
        async detailShow(row){
            this.isDetailDialog = true;
            this.detailData = row;
        },
        
    }
    
}
</script>

<style lang="scss" scoped>
    .person{
        height: 700px;
    }
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        padding-top: 30px;
        font-size: 14px;
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .picList{
        display: flex;
        flex-wrap: wrap;
        margin:0 10px;
        .pic{
            position: relative;
            margin: 5px;
            width: 100px;
            height: 100px;
            .pic-edit{
                position: absolute;
                z-index: 10;
                top: -10px;
                right: -10px;
                width: 22px;
                height: 22px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                i{
                    color: #ffffff;
                }
                .error{
                    color: #f56c6c;
                }
                .success{
                    color: #a9ffa9;
                }
            }
        }
    }
    /deep/.el-input.is-disabled .el-input__inner{
        color: #333333;
    }
    /deep/.el-textarea.is-disabled .el-textarea__inner{
        color: #333333;
    }
</style>
